export default __webpack_public_path__ + "static/media/11.ba2ac94e.webp";